// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"7ab84156","227":"b5d51f89","258":"1e619484","451":"982a0e51","453":"1565647e","500":"84719703","648":"ff01c8e5","961":"d85a51c1"}[chunkId] + ".chunk.js";
};